var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WrapperImage',{style:({ backgroundImage: `url(${require(`@/assets/bg/${_vm.image}/bg.jpg`)})` })},[_c('WrapperPattern',{style:({ backgroundImage: `url(${require(`@/assets/bg/pattern.png`)})` })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }